import { create } from 'zustand';
import { PaginationType } from '../types/pagination';
import {
  deleteSection,
  DishSectionType,
  postSection,
  putSection,
  putSectionsOrder,
} from './api/dish-section-api';
import { useAlertStore } from './use-alert-store';
import { getMenuId } from '../pages/manager/body/menu/menu-informer/menu-informer-helpers';
import {
  createMenuSection,
  deleteMenuSection,
  sortMenuSections,
  updateMenuSection,
} from '../pages/manager/body/menu/menu-informer/menu-informer-section-helpers';

interface Store extends Partial<PaginationType> {
  postSection: (section: Pick<DishSectionType, 'name'>) => Promise<DishSectionType | undefined>;
  putSection: (section: DishSectionType) => Promise<void>;
  deleteSection: (id: string) => Promise<void>;
  setSectionListOrder: (order: number[]) => void;
  isLoading?: boolean;
}

export const useDishSectionStore = create<Store>((set) => ({
  postSection: async (section) => {
    set({ isLoading: true });
    let resp: DishSectionType | undefined;
    try {
      resp = await postSection({ ...section, menu_id: getMenuId() });
      createMenuSection(resp);
      useAlertStore.getState().add({ label: 'Раздел успешно добавлен', variant: 'success' });
    } catch (e) {
      resp = undefined;
      console.error(e);
      useAlertStore
        .getState()
        .add({ label: 'Не удалось сохранить данные по разделу', variant: 'danger' });
    } finally {
      set({ isLoading: false });
    }
    return resp;
  },
  putSection: async (section) => {
    set({ isLoading: true });
    try {
      const resp = await putSection(section);
      updateMenuSection(resp);
      useAlertStore.getState().add({ label: 'Раздел успешно обновлен', variant: 'success' });
    } catch (e) {
      console.error(e);
      useAlertStore
        .getState()
        .add({ label: 'Не удалось обновить данные по разделу', variant: 'danger' });
      throw e;
    } finally {
      set({ isLoading: false });
    }
  },
  deleteSection: async (id) => {
    set({ isLoading: true });
    try {
      await deleteSection(id);
      useAlertStore.getState().add({ label: 'Раздел успешно удален', variant: 'success' });
      deleteMenuSection(id);
    } catch (e) {
      console.error(e);
      useAlertStore.getState().add({ label: 'Не удалось удалить раздел', variant: 'danger' });
    } finally {
      set({ isLoading: false });
    }
  },

  setSectionListOrder: async (order) => {
    set({ isLoading: true });
    try {
      await putSectionsOrder(order);
      sortMenuSections(order);

      useAlertStore
        .getState()
        .add({ label: 'Порядок разделов успешно сохранен', variant: 'success' });
    } catch (e) {
      console.error(e);
      useAlertStore
        .getState()
        .add({ label: 'Не удалось сохранить порядок разделов', variant: 'danger' });
    } finally {
      set({ isLoading: false });
    }
  },
}));
